import React, { Component } from 'react'
import styled from 'styled-components'
import { Input } from '../components/styles/form'
import { CtaBtn } from '../../../components'
import { linkEMRUser, searchEMRUsers } from '../../../rest'
import CheckIcon from '../../../lib/assets/icons/check-status.svg'

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 550px;
    margin: auto;

    a {
        color: #006264;
        text-decoration: underline;
        
        &:hover {
            cursor:pointer;
        }
    }
`
const Title = styled.h3`
    color: #000000;
    font-size: 20px;
    text-align:center;
    font-weight: 400;
    max-width: 400px;
`

const SearchInput = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;

    label {
        text-align:left;
    }

    Input {
        margin: 10px 0;
    }


    button {
        align-self: center;
        width: 200px;
    }
    
`

const SearchResults = styled.div`
    * {
        box-sizing: border-box;
    }
    margin-top: 50px;
    .box-container {
        margin: 10px 0;
        max-width: 560px;
        max-height: 200px;
        border-radius: 4px;
        box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
        background-color: #ffffff;
        overflow-y: auto; 

        .result {
            width: 100%;
            padding: 15px;
            p {
                margin: 2px 0;
                font-size: 14px;            
                padding-right: 30px;
            }
        }        
    }

`

const EmrUserContainer = styled.div`
  position: relative;
  background: ${props => props.selected ? '#f0f4ef' : 'white'};
  &:hover {
    background: ${props => props.selected ? '#f0f4ef' : 'rgba(0, 0, 0, 0.04)'};
    cursor: pointer;
  }
`

const SelectedIcon = styled.img.attrs({
  src: CheckIcon
})`
    position: absolute;
    width: 30px;
    right: 20px;
    bottom: 30px;
`

class EHRSearch extends Component {
  state = {
    query: this.props.intialName,
    selectedUser: null,
    isSearchingLoading: false,
    isLinkingUserLoading: false,
    hasSearched: false,
    searchResults: []
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  onHandleEmrUsersSearch = () => {
    const { query } = this.state
    const { email, token, organizationId, emr, sukiUserId } = this.props
    const emrOrgId = emr?.id

    // set search loading
    this.setState({ isSearchingLoading: true })

    // make search call
    searchEMRUsers({ email, token, query, organizationId, emrOrgId, sukiUserId }).then(res => {
      // save results to state
      const searchResults = res?.users || []
      this.setState({ searchResults, isSearchingLoading: false, hasSearched: true })
    })
  }

  handleSelectUser = (selectedUser) => {
    this.setState({ selectedUser })
  }

  onHandleLinkUser = () => {
    const { selectedUser } = this.state
    const { email, token, sukiUserId, timezone, organizationId, onFinishedLinkingUser } = this.props

    this.setState({ isLinkingUserLoading: true })
    const { emrUserId, emrDepartmentId } = selectedUser
    const emrUserIdList = emrUserId ? [emrUserId] : []

    linkEMRUser({ email, token, organizationId, sukiUserId, emrUserId, emrUserIdList, emrDepartmentId, timezone }).then(res => {
      const emrUser = {
        emrUserId,
        emrDepartmentId
      }
      onFinishedLinkingUser(emrUser)

      this.setState({ isLinkingUserLoading: false })
    })
  }

  handleDontSee = () => {
    const { onHandleBypassEMR } = this.props
    onHandleBypassEMR()
  }

  renderSearchResults = () => {
    const { searchResults, selectedUser } = this.state

    if (searchResults.length === 0) return

    const emrUsers = searchResults.map(emrUser => {
      const emrName = `${emrUser?.emrFirstName} ${emrUser?.emrLastName}`
      const selected = selectedUser?.emrUserId === emrUser?.emrUserId
      return (
        <EmrUserContainer key={emrUser?.emrUserId} className='result' onClick={(e) => this.handleSelectUser(emrUser)} selected={selected}>
          <p className='name'><strong>{emrName}</strong> </p>
          <p className='secondary'>{emrUser?.emrUserId}</p>
          <p className='secondary'>{emrUser?.emrDepartmentName}</p>
          {selected && <SelectedIcon />}
        </EmrUserContainer>
      )
    })

    return (
      <SearchResults>
        <label>Choose the EHR account we should link to:</label>

        <div className='box-container'>
          {emrUsers}
        </div>
      </SearchResults>
    )
  }

  render () {
    const {
      hasSearched,
      query,
      selectedUser,
      isSearchingLoading,
      isLinkingUserLoading
    } = this.state
    return (
      <Container>
        <Title>Please verify your information so we can find your Athena account</Title>
        <SearchInput>
          <label>Name as used in your EHR</label>
          <Input name='query' value={query} onChange={this.handleChange} autoFocus />
          <CtaBtn
            isLoading={isSearchingLoading}
            styleType='secondary'
            handleClick={this.onHandleEmrUsersSearch}
          >
            {isSearchingLoading ? 'Loading' : 'Search'}
          </CtaBtn>
        </SearchInput>
        {this.renderSearchResults()}
        {selectedUser ? <CtaBtn isLoading={isLinkingUserLoading} handleClick={this.onHandleLinkUser}>Verify</CtaBtn> : hasSearched && <a onClick={this.handleDontSee}>Don't see your name here?</a>}

      </Container>
    )
  }
}

export default EHRSearch
